import { CMLEditorNaptime as CMLEditor } from '@coursera-web/cml';

export type { CMLEditorNaptimeProps as Props } from '@coursera-web/cml';

export default CMLEditor;
